import { FullscreenPanorama } from 'shared/components/FullscreenPanorama';
import { TPanorama } from '../../types';
import { usePanoramaPlayer } from '../../hooks';
import { FC, useRef } from 'react';

interface IFullscreenPanoramaContainerProps {
  panorama: TPanorama;

  onClose: VoidFunction;
}

export const FullscreenPanoramaContainer: FC<IFullscreenPanoramaContainerProps> = ({ panorama, onClose }) => {
  const panoramaRef = useRef<HTMLDivElement>(null);

  usePanoramaPlayer({ panorama, onClose, panoramaContainerRef: panoramaRef });

  return <FullscreenPanorama ref={panoramaRef} />;
};
